export default {
  TOP_TRACKS: "TOP_TRACKS",
  TRACKS_AZ: "TRACKS_AZ",
  RESULTED_TRACKS_AZ: "RESULTED_TRACKS_AZ",
  FAVORITE_TRACKS: "FAVORITE_TRACKS",
  RESULTED_FAVORITE_TRACKS: "RESULTED_FAVORITE_TRACKS"
};
